import Router from "@/helpers/router";

export const SALES_FLOOR_DYNAMIC_ROUTE = "/sales-floor/[...salesFloorSlug]";

export const APP_LAYOUT_SUPPORTED_ROUTES = [
  Router.home(),
  Router.dashboard(),
  Router.coaching(),
  Router.accounts(),
  Router.lists(),
  Router.callHistory(),
  Router.marketplace(),
  decodeURI(Router.marketplaceCampaign("[campaign_id]")),
  Router.performanceDashboard(),
  Router.topCalls(),
  Router.leaderboard(),
  Router.messages(),
  Router.emailInbox(),
  Router.settingsReferrals(),
  Router.salesFloor(),
  Router.myWeek(),
  // --- C-14 roles: manage pages (F1 owns this block; F3 appends its pages) ---
  Router.manageAdmin(),
  Router.manageCalendar(),
  // C-12 wave 2: Team → Health (was Rep Health and Campaign Health).
  Router.manageHealth(),
  // C-16 S3: Team → Pipeline.
  Router.managePipeline(),
  // C-16 S3: Team → Forecast.
  Router.manageForecast(),
  // W2 (C-14 phase 2)
  Router.manageAnalytics(),
  // C-14 phase 2 W4
  Router.manageActivity(),
  Router.manageLeaderboard(),
  // C-14 phase 2 W3
  Router.manageReps(),
  // --- end C-14 block ---
  // --- C-16 S1: Rewards + Team → Incentives (GLE-8408) ---
  Router.rewards(),
  Router.reward(),
  Router.manageIncentives(),
  Router.manageIncentive(),
  Router.manageIncentiveNew(),
  Router.manageIncentiveEdit(),
  // C-16 S6: Leads → To-Dos (GLE-8406).
  Router.todos(),
  // C-16 S2: Team → EOM (GLE-8409).
  Router.manageEom(),
  SALES_FLOOR_DYNAMIC_ROUTE,
  "/dashboard-v4",
  "/messages/new",
];

export const RESPONSIVE_PAGE_ROUTES = [
  // Router.accountDetails("[campaign_id]", "[account_id]"),
];
